var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.001,
    height: 21.997,
    viewBox: "0 0 22.001 21.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4574",
    "data-name": "Group 4574",
    transform: "translate(-20.999 -847.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7483",
    "data-name": "Path 7483",
    d: "M141.715,230.953h-5.328a2.105,2.105,0,0,1,0-4.211h3.2l-1.29-1.289h-1.9a3.395,3.395,0,0,0,0,6.789h5.328a2.108,2.108,0,0,1,2.105,2.105v.043a2.108,2.108,0,0,1-2.105,2.105H129.927l-1.29,1.289h13.078a3.4,3.4,0,0,0,3.395-3.395v-.043A3.4,3.4,0,0,0,141.715,230.953Zm0,0",
    transform: "translate(-102.109 631.213)",
    fill: "#63666f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_22",
    "data-name": "Subtraction 22",
    d: "M863,10479h0l-2.826-2.93a4.245,4.245,0,0,1,0-5.859,3.909,3.909,0,0,1,5.657,0,4.252,4.252,0,0,1,0,5.859L863,10479Zm0-8a2,2,0,1,0,2,2A2,2,0,0,0,863,10471Z",
    transform: "translate(-838 -9611)",
    fill: "#63666f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_23",
    "data-name": "Subtraction 23",
    d: "M863,10479h0l-2.826-2.93a4.245,4.245,0,0,1,0-5.859,3.909,3.909,0,0,1,5.657,0,4.252,4.252,0,0,1,0,5.859L863,10479Zm0-8a2,2,0,1,0,2,2A2,2,0,0,0,863,10471Z",
    transform: "translate(-824 -9622)",
    fill: "#63666f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrip);
export default __webpack_public_path__ + "static/media/trip.13a26c23dd86582443d8b0bd13202ae7.svg";
export { ForwardRef as ReactComponent };